import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableRow from "./TableRow"

class TableBody extends Component {
    _renderTableContent = () => {
        const {loading, orders, error} = this.props

        if (loading) {
            return <tr>
                <td colSpan={14}>Loading ...</td>
            </tr>
        }

        if (orders.length === 0 && !error) {
            return <tr>
                <td colSpan={14}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={14} className='text-danger'>{error}</td>
            </tr>
        }

        return orders.length > 0 && orders.map((item) => {
            return <TableRow key={item._id} item={item}/>
        })
    }

    render() {
        return (
            <tbody className="TableBody">
            {this._renderTableContent()}
            </tbody>
        )
    }
}

TableBody.propTypes = {
    error: PropTypes.string,
    orders: PropTypes.array,
    loading: PropTypes.bool,
}

export default TableBody
